import { Link } from "react-router-dom";
import { movies, siteInfo } from "@/lib/movieData";

const stats = [
  { value: `${movies.length}`, label: "部影片资料" },
  { value: "8", label: "个影片类型" },
  { value: `${movies.length * 2}`, label: "条资讯动态" },
  { value: "每日", label: "内容更新" },
];

export default function IntroBand() {
  return (
    <section className="relative w-full bg-primary-950 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.14]">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20stylized%20film%20strip%20and%20light%20beams%20on%20dark%20navy%20background%2C%20minimal%20cinematic%20texture%2C%20warm%20amber%20highlight%20edges%2C%20no%20text&width=1600&height=600&seq=intro-band-01&orientation=landscape"
          alt="影视内容聚合平台背景装饰"
          title="秋霞电影 - 影视内容聚合平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1180px] mx-auto grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
          <div>
            <p className="text-[11px] tracking-[0.3em] text-accent-300 uppercase">About Qiu Xia</p>
            <h1 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight">
              秋霞电影
            </h1>
            <p className="mt-2 font-heading text-lg md:text-xl text-background-100/80">
              {siteInfo.slogan}
            </p>
            <p className="mt-5 max-w-[560px] text-sm leading-relaxed text-primary-100/75">
              {siteInfo.description}
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                了解站点
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category/drama"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-50/30 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap"
              >
                开始浏览片库
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-px rounded-lg overflow-hidden border border-primary-700/60 bg-primary-700/40">
            {stats.map((stat) => (
              <div key={stat.label} className="bg-primary-900/80 px-5 py-7">
                <p className="font-heading text-2xl md:text-3xl text-background-50">{stat.value}</p>
                <p className="mt-2 text-xs text-primary-200/80">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}